module.exports = __webpack_public_path__ + "static/media/post.d9f49456.png";